import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Draggable from 'react-draggable';

class CardPreview extends Component {
    render() {
        return (
            <Draggable>
                <div className="CardPreview">
                    <div className="row ">
                        <div className="col-xs-12">
                            <div
                                className="col-xs-12 card-image handle"
                                style={{ backgroundImage: 'url(../../../../public/images/cardImage.jpg)' }}
                            ></div>
                        </div>
                        <div className="col-xs-12">
                            <div className="col-xs-12">
                                <div className="col-xs-12">
                                    <div
                                        className="card-title"
                                        style={{
                                            fontFamily: this.props.title.font,
                                            textAlign: this.props.title.align,
                                            lineHeight: this.props.title.lineHeight,
                                            textDecoration: this.props.title.decoration,
                                            fontStyle: this.props.title.style,
                                            color: this.props.title.color,
                                            fontWeight: this.props.title.weight,
                                            fontSize: this.props.title.size
                                        }}
                                    >
                                        ROYAL DELUXE KING SUITE
                                    </div>
                                    <div
                                        className="card-subtitle"
                                        style={{
                                            fontFamily: this.props.subtitle.font,
                                            textAlign: this.props.subtitle.align,
                                            lineHeight: this.props.subtitle.lineHeight,
                                            textDecoration: this.props.subtitle.decoration,
                                            fontStyle: this.props.subtitle.style,
                                            color: this.props.subtitle.color,
                                            fontWeight: this.props.subtitle.weight,
                                            fontSize: this.props.subtitle.size
                                        }}
                                    >
                                        Go Team! Promotional Rate
                                    </div>
                                    <div
                                        className="card-link row"
                                        style={{
                                            fontFamily: this.props.defaultLink.font,
                                            textAlign: this.props.defaultLink.align,
                                            lineHeight: this.props.defaultLink.lineHeight,
                                            textDecoration: this.props.defaultLink.decoration,
                                            fontStyle: this.props.defaultLink.style,
                                            color: this.props.defaultLink.color,
                                            fontWeight: this.props.defaultLink.weight,
                                            fontSize: this.props.defaultLink.size
                                        }}
                                    >
                                        <div className="col-xs-3">DETAILS</div>
                                        <div className="col-xs-6 second-link">QUICK VIEW</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12 ">
                                            <div
                                                className="text-center card-price "
                                                style={{
                                                    fontFamily: this.props.largePrice.font,
                                                    textAlign: this.props.largePrice.align,
                                                    lineHeight: this.props.largePrice.lineHeight,
                                                    textDecoration: this.props.largePrice.decoration,
                                                    fontStyle: this.props.largePrice.style,
                                                    color: this.props.largePrice.color,
                                                    fontWeight: this.props.largePrice.weight,
                                                    fontSize: this.props.largePrice.size
                                                }}
                                            >
                                                $238
                                            </div>
                                        </div>
                                        <div className="col-xs-12 text-center">per night</div>
                                    </div>
                                    <button className="add-to-cart-button">ADD TO CART</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Draggable>
        );
    }
}

CardPreview.propTypes = {
    title: PropTypes.object,
    subtitle: PropTypes.object,
    defaultLink: PropTypes.object,
    largePrice: PropTypes.object
};

const mapStateToProps = state => {
    return { ...state.app.data.theme.card, ...state.theme.card };
};

export default connect(mapStateToProps)(CardPreview);



// WEBPACK FOOTER //
// ./src/components/pages/theme/card/Preview.js